import React from 'react';

import { Skeleton } from '@material-ui/lab';

import { TileSelectionSkeletonProps } from './TileSelectionSkeleton.types';

const TileSelectionSkeleton: React.FC<TileSelectionSkeletonProps> = ({
  className
}) => {
  return (
    <div className={`flex ${className}`}>
      <Skeleton variant="rect" width={68} height={56} className="mr4 br2" />
      <Skeleton variant="rect" width={68} height={56} className="mr4 br2" />
      <Skeleton variant="rect" width={68} height={56} className="mr4 br2" />
    </div>
  );
};
export default TileSelectionSkeleton;
export { TileSelectionSkeletonProps };
